import React, { useEffect, useState } from "react";
import localStorageService from "../../services/localStorage.service";
import GTMServiceAPI from "../../services/gtm.API.service";
import LoadingScreen from "../../components/elements/LoadingScreen";
import { Select, ConfigProvider, Button } from "antd";
import { Steps, Alert, Space } from "antd";
import FullLoadingScreen from "./FullLoadingScreen";
import colors from "../../styles/_colors.scss";
import { Tooltip as AntdTooltip } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
// C:\Users\relevantonline\Documents\codecube\portal\frontend\src\styles\_colors.scss
// C:\Users\relevantonline\Documents\codecube\portal\frontend\src\pages\GTM\googleCallBack.js

const { Step } = Steps;

export const AuthorizedGTM = (props) => {
  const [containers, setContainers] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loadingActive, setLoadingActive] = useState(false);
  const [loadingWithTextActive, setLoadingWithTextActive] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedContainer, setSelectedContainer] = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [tagsUpdated, setTagsUpdated] = useState(false);
  const [current, setCurrent] = useState(0);

  const authorizedGTM = props.authorizedGTM;
  const authUrl = props.authUrl;
  const UserEmail = localStorageService.getUserData()?.email;

  const successMessage = `
        Tags updated successfully.
        Please navigate to your container and review the changes in the newly 
        generated Code-Cube.io workspace. Then, publish the container for the changes
        to take effect.
    `;

  const HandleSelectContainer = async (containerId) => {
    const selectedFilterName = containers.find(
      (id) => id.containerId === containerId,
    );
    setSelectedContainer(selectedFilterName);
  };

  const handleRunUpdate = async () => {
    // Send a request to check if the session is active
    // setLoadingActive(true);
    setLoadingWithTextActive(true);
    const response = await GTMServiceAPI.GetTags(
      selectedContainer.containerId,
      selectedAccount,
      UserEmail,
    );
    
    // Check if credentials have expired
    if (response?.credentials_expired) {
      setErrorMsg(response.error || "Your Google authentication has expired. Please re-authenticate.");
      setShowMessage(true);
      props.setAuthorizedGTM(false);
      // Fetch new auth URL for re-authentication
      if (props.fetchAuthUrl) {
        await props.fetchAuthUrl();
      }
      setLoadingWithTextActive(false);
      return;
    }
    
    setErrorMsg(response?.response_object?.error_msg);
    // setLoadingActive(false);
    setTagsUpdated(response?.response_object?.updated_tags);
    setShowMessage(true);
    setLoadingWithTextActive(false);
  };

  const HandleSelectAccount = async (accountId) => {
    // Send a request to check if the session is active
    setLoadingActive(true);
    const response = await GTMServiceAPI.GetContainers(accountId, UserEmail);
    
    // Check if credentials have expired
    if (response?.credentials_expired) {
      setErrorMsg(response.error || "Your Google authentication has expired. Please re-authenticate.");
      setShowMessage(true);
      props.setAuthorizedGTM(false);
      // Fetch new auth URL for re-authentication
      if (props.fetchAuthUrl) {
        await props.fetchAuthUrl();
      }
      setLoadingActive(false);
      return;
    }
    
    setContainers(response?.response_object?.containers?.container);
    setSelectedAccount(accountId);
    setLoadingActive(false);
  };

  // get all accounts for the user
  useEffect(() => {
    (async () => {
      setLoadingActive(true);
      // Send a request to check if the session is active
      const response = await GTMServiceAPI.GetAccounts(UserEmail);
      
      // Check if credentials have expired or are invalid
      if (response?.credentials_expired || response?.credentials_not_found || !response) {
        setErrorMsg(
          response?.error || "Your Google authentication is invalid. Please re-authenticate."
        );
        setShowMessage(true);
        props.setAuthorizedGTM(false);
        // Fetch new auth URL for re-authentication
        if (props.fetchAuthUrl) {
          await props.fetchAuthUrl();
        }
        setLoadingActive(false);
        return;
      }
      
      setAccounts(response?.response_object?.accounts?.account);
      setLoadingActive(false);
    })();
  }, []);

  // set the current step accordingly
  useEffect(() => {
    if (!authorizedGTM) {
      setCurrent(0);
    } else if (authorizedGTM && (!accounts || accounts.length === 0)) {
      // Authentication is complete, so keep step 1 checked and move to step 2.
      setCurrent(1);
    } else if (
      authorizedGTM &&
      accounts?.length > 0 &&
      containers?.length > 0 &&
      Object.keys(selectedContainer)?.length > 0 &&
      tagsUpdated
    ) {
      setCurrent(4);
    } else if (
      authorizedGTM &&
      accounts?.length > 0 &&
      containers?.length > 0 &&
      Object.keys(selectedContainer)?.length > 0
    ) {
      setCurrent(3);
    } else if (
      authorizedGTM &&
      accounts?.length > 0 &&
      containers?.length > 0
    ) {
      setCurrent(2);
    } else if (authorizedGTM && accounts?.length > 0) {
      setCurrent(1);
    }
  }, [
    authorizedGTM,
    accounts,
    containers,
    current,
    selectedContainer,
    tagsUpdated,
  ]);

  useEffect(() => {
    setShowMessage(false);
  }, [selectedContainer, selectedAccount]);

  return (
    <div>
      <LoadingScreen isActive={loadingActive} />
      <FullLoadingScreen isActive={loadingWithTextActive} />
      
      <ConfigProvider
        theme={{
          components: {
            Steps: {
              colorPrimary: colors.ccDarkBlue,
              processIconColor: colors.ccDarkBlue,
              customIconTop: "50%",
              customIconTransform: "translateY(-50%)",
              finishIconBorderColor: colors.ccDarkBlue,
              colorTextDescription: "rgba(0, 0, 0, 0.88)",
              waitIconColor: "rgba(0, 0, 0, 0.25)",
              waitDotColor: "rgba(0, 0, 0, 0.25)",
            },
          },
        }}
      >
        <Steps current={current} direction="vertical">
          <Step
            title="Google authentication"
            style={{ paddingBottom: "2rem" }}
            description={
              <div>
                <p>
                  To automate changes to your Tag Manager container, please
                  authenticate your Google account. Click the button below and
                  follow the on-screen instructions provided by Google.
                </p>

                <div className={authorizedGTM ? `disabled-div` : ""}>
                  <Button type="default">
                    <a href={authUrl}>start authentication</a>
                  </Button>
                </div>
                {/* <div style={{ height: "3rem", opacity: 1 }}></div> */}
              </div>
            }
          />
          <Step
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <span>Select an account</span>
                <AntdTooltip title="Applies to both client-side and server-side containers.">
                  <InfoCircleFilled
                    className="info-icon"
                    style={{ marginLeft: "8px", fontSize: "16px", cursor: "pointer" }}
                  />
                </AntdTooltip>
              </div>
            }
            style={{ paddingBottom: "2rem" }}
            description={
              <div className="row">
                <div className={authorizedGTM ? "" : "disabled-div"} style={{marginTop: "0.5rem"}}>
                  <Select
                    className="bulk-edit-select"
                    showSearch
                    placeholder="Select an account"
                    optionFilterProp="label"
                    onChange={(e) => {
                      HandleSelectAccount(e);
                    }}
                    filterOption={true}
                    disabled={!authorizedGTM}
                    notFoundContent="No GTM accounts available."
                    options={accounts?.map((account) => {
                      return { value: account.accountId, label: account.name };
                    })}
                  />
                </div>
              </div>
            }
          />
          <Step
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <span>Select a container</span>
                <AntdTooltip title="Applies to both client-side and server-side containers.">
                  <InfoCircleFilled
                    className="info-icon"
                    style={{ marginLeft: "8px", fontSize: "16px", cursor: "pointer" }}
                  />
                </AntdTooltip>
              </div>
            }
            style={{ paddingBottom: "2rem" }}
            description={
              <div className="row">
                <div className={selectedAccount ? "" : "disabled-div"} style={{marginTop: "0.5rem"}}>
                  <Select
                    className="bulk-edit-select"
                    showSearch
                    placeholder="Select a container"
                    optionFilterProp="label"
                    onChange={(e) => HandleSelectContainer(e)}
                    disabled={!selectedAccount}
                    filterOption={true}
                    notFoundContent="You don't have access to GTM containers."
                    options={containers?.map((container) => {
                      return {
                        value: container.containerId,
                        label: container.name,
                      };
                    })}
                  />
                </div>
              </div>
            }
          />

          <Step
            title="Update the selected container."
            style={{ paddingBottom: "2rem" }}
            description={
              <div className={authorizedGTM ? `` : "disabled-div"}>
                <Button 
                  type="run_update" 
                  onClick={handleRunUpdate}
                  style={{ marginTop: "0.5rem" }}
                  >
                  Run update
                </Button>
              </div>
            }
          />
        </Steps>

        {tagsUpdated && showMessage && (
          <Space
            direction="vertical"
            style={{ width: "40rem", marginTop: "2rem" }}
          >
            <Alert
              message={`${selectedContainer.name} workspace successfully updated!`}
              description={successMessage}
              type="success"
              closable
            />
          </Space>
        )}

      </ConfigProvider>
    </div>
  );
};

export default AuthorizedGTM;
